module.exports = __webpack_public_path__ + "static/img/overdue.1a3cbf44.png";